/** @format */

import {Trans} from 'react-i18next';

import {HintIconTooltip} from 'pages/Home/Main/Project/components/HintIconTooltip';

import {PredictionData} from '../../interfaces';
import {
  CenterLineWrap,
  LeftCol,
  MainContent,
  NotAvailableText,
  PredictionValue,
  RightCol,
  VerticalLine,
  WidgetTooltip,
} from '../../styles';
import {getGradientByDeviation} from '../../utils';
import {TooltipContent} from '../TooltipContent';
import {WidgetContainer} from '../../../../styles';

interface WidgetIsNotAvailableProps {
  data: PredictionData | null;
  tooltipContent: React.ReactNode;
}

const WidgetIsNotAvailable = ({data, tooltipContent}: WidgetIsNotAvailableProps) => {
  return (
    <WidgetContainer isCenterContent>
      <WidgetTooltip data-testid='project-prediction'>
        <HintIconTooltip title={tooltipContent || <TooltipContent />} placement='top' />
      </WidgetTooltip>
      <MainContent>
        <LeftCol>
          <PredictionValue>
            <Trans>Прогноз на</Trans>
            <br />
            {data?.targetDateFormatted || ''}
          </PredictionValue>
        </LeftCol>
        <CenterLineWrap>
          <VerticalLine gradient={getGradientByDeviation(100)} />
        </CenterLineWrap>
        <RightCol isNotAvailable>
          <NotAvailableText>
            <Trans>Пока не доступен</Trans>
          </NotAvailableText>
        </RightCol>
      </MainContent>
    </WidgetContainer>
  );
};

export default WidgetIsNotAvailable;
